import { Helmet } from 'react-helmet-async'
import Section from '../components/common/Section'
import Biography from '../components/vita/Biography'
import Influences from '../components/vita/Influences'
import artistData from '../data/artist.json'

export default function VitaPage() {
  return (
    <>
      <Helmet>
        <title>Vita - Gabriele Wiedemann</title>
        <meta
          name="description"
          content="Erfahren Sie mehr über Gabriele Wiedemann, ihre künstlerische Entwicklung und Einflüsse."
        />
        <meta property="og:title" content="Vita - Gabriele Wiedemann" />
        <meta
          property="og:description"
          content={artistData.bio.short}
        />
        <meta property="og:type" content="profile" />
      </Helmet>

      <div>
        {/* Biography Section */}
        <Section background="white" padding="large">
          <Biography />
        </Section>

        {/* Influences Section */}
        <Section background="neutral" padding="large">
          <Influences />
        </Section>
      </div>
    </>
  )
}
